<template>
  <div class="riderauthentication">
    <div class="outmain heighthv bor_rad5 ba_f">
      <div class="ba_f">
        <div class="shuju_title mar_b20">
          <div class="shuju_title_text">
            <span>{{ $t('rider.auth.title') }}</span>
          </div>
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline searchform" style="min-width: 1300px;">
          <div class="flex mar_t20 mar_b20">
            <el-form-item :label="$t('rider.auth.status')">
              <el-select v-model="formInline.state" :placeholder="$t('common.pleaseSelect')" @change="onSearch">
                <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('rider.list.name')" class="mar_l20">
              <el-input v-model="formInline.name" size="medium" :placeholder="$t('rider.list.namePh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item :label="$t('rider.list.tel')" class="mar_l20">
              <el-input v-model="formInline.tel" size="medium" :placeholder="$t('rider.auth.telPh')" @input="onSearch"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch" size="medium">{{ $t('common.filter') }}</el-button>
              <el-button type="primary" @click="handleOperate('', 'adopt')" size="medium">{{ $t('rider.auth.batchPass') }}</el-button>
              <el-button type="warning" @click="handleOperate('', 'reject')" size="medium">{{ $t('rider.auth.batchReject') }}</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div class="mar_b20">
          <el-button type="primary" @click="addRider">{{ $t('rider.auth.addRider') }}</el-button>
        </div>
      </div>
      <div>
        <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="userName" :label="$t('common.riderAccount')"></el-table-column>
          <el-table-column :label="$t('common.realName')" align="center">
            <template slot-scope="scope">{{ scope.row.name || '--' }}</template>
          </el-table-column>
          <el-table-column prop="tel" :label="$t('rider.auth.bindPhone')" align="center"></el-table-column>
          <el-table-column prop="code" :label="$t('rider.auth.idCard')" align="center" min-width="200">
            <template slot-scope="scope">{{ scope.row.state == 3 ? '--' : (scope.row.code || '--') }}</template>
          </el-table-column>
          <el-table-column prop="state" :label="$t('rider.auth.authStatus')" min-width="150" align="center">
            <template slot-scope="scope">
              <div class="flex flex-justify-center" v-if="!scope.row.state || scope.row.state == 4">
                <section class="debug-d debug-small" style="background: #999;"></section>
                <div>{{ $t('common.notCertified') }}</div>
              </div>
              <div class="flex flex-justify-center" v-if="scope.row.state == 1">
                <section class="debug-d debug-small" style="background: #2a75ed;"></section>
                <div style="color: #2a75ed;">{{ $t('common.reviewing') }}</div>
              </div>
              <div class="flex flex-justify-center" v-if="scope.row.state == 2">
                <section class="debug-d debug-small" style="background: #18BC9C;"></section>
                <div style="color: #18BC9C;">{{ $t('common.certified') }}</div>
              </div>
              <div class="flex flex-justify-center" v-if="scope.row.state == 3">
                <section class="debug-d debug-small" style="background: #fa4000;"></section>
                <div style="color: #fa4000;">{{ $t('rider.auth.authReject') }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" :label="$t('common.regTime')" min-width="150" align="center"></el-table-column>
          <el-table-column :label="$t('common.operation')" align="center" width="180" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.state == '1'" @click="handleOperate(scope.row.aid, 'adopt')">{{ $t('common.pass') }}</el-button>
              <el-button type="text" v-if="scope.row.state == '1'" @click="handleOperate(scope.row.aid, 'reject')" style="color: red;">{{ $t('common.reject') }}</el-button>
              <el-button type="text" @click="handleSeeEdit(scope.row)">{{ $t('common.detail') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <rider-add ref="RiderAdd" v-if="RiderAdd" @close="RiderAdd = false" @refreshData="fetchData"></rider-add>
  </div>
</template>
<script>
import RiderAdd from './rider-add.vue';
import { authenticationList, riderOperate } from '@/api/rider';
export default {
  components: { RiderAdd },
  data() {
    return {
      RiderAdd: false,
      formInline: { state: '0', name: '', tel: '' },
      list: [],
      listLoading: true,
      selectRows: [],
      page: { total: 0, pagesize: 10, currentPage: 1 },
    };
  },
  computed: {
    stateOptions() {
      return [
        { value: '0', label: this.$t('rider.auth.allStatus') },
        { value: '1', label: this.$t('rider.auth.pendingReview') },
        { value: '2', label: this.$t('common.certified') },
        { value: '4', label: this.$t('common.notCertified') },
      ];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    addRider() {
      this.RiderAdd = true;
      this.$nextTick(() => this.$refs.RiderAdd.init());
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    onSearch() {
      this.fetchData();
    },
    handleSeeEdit(row) {
      this.$router.push({
        name: 'riderEditInfo',
        query: { id: row.id, routerName: 'riderauthentication' },
      });
    },
    handleOperate(id, type) {
      const actionMap = {
        adopt: this.$t('common.pass'),
        reject: this.$t('common.reject'),
        delete: this.$t('common.delete'),
      };
      const text = actionMap[type] || '';
      if (id) {
        this.$baseConfirm(this.$t('confirm.actionItem', { action: text }), null, async () => {
          const { msg } = await riderOperate({ id: [id], type });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      } else if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.aid);
        this.$baseConfirm(this.$t('confirm.actionSelected', { action: text }), null, async () => {
          const { msg } = await riderOperate({ id: ids, type });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      } else {
        this.$baseMessage(this.$t('common.noRowSelected'), 'error');
      }
    },
    async fetchData() {
      const params = { page: this.page.currentPage };
      if (this.formInline.name) params.name = this.formInline.name;
      if (this.formInline.tel) params.tel = this.formInline.tel;
      if (this.formInline.state) params.state = this.formInline.state;
      const { data, count } = await authenticationList(params);
      this.list = data;
      this.page.total = count;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    },
  },
};
</script>
<style lang="stylus" scoped>
.riderauthentication {
  min-width: 1300px;
}
</style>
